import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,[_c(VCol,{attrs:{"cols":"auto"}},[_c(VIcon,{staticClass:"mt-2"},[_vm._v(" mdi-translate ")])],1),_c(VCol,{attrs:{"cols":"5"}},[_c(VSelect,{attrs:{"dense":"","items":_vm.langs},model:{value:(_vm.selectedLanguage),callback:function ($$v) {_vm.selectedLanguage=$$v},expression:"selectedLanguage"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }